export default {
  pageTitle: 'NDDC Store Configuration',
  storeCode: 'Store Code',
  storeName: 'Store Name',
  platformType: 'Platform Type',
  sapStoreCode: 'SAP Store Code',
  inventoryEntityCode: 'Inventory Entity Code',
  senderAddress: 'Sender Address',
  status: 'Status',
  selectData: 'Please select one row.',
  disableConfirm: 'Are you sure to disable this Store?',
  activeConfirm: 'Are you sure to activate this Store?',
  disableWrongStatus: 'Only active records can be disabled.',
  activeWrongStatus: 'Only disabled records can be activated.',
  errorcode_8001: 'The store code already exists. Please search for it on the page before making any edits or updates.',
  errorcode_8002:
    'The SAP Store Code already exists. Please search for it on the page before making any edits or updates.',
  errorcode_8003: 'The shipTo already exists. Please search for it on the page before making any edits or updates.',
  errorcode_8004:
    'The Inventory Entity Code already exists. Please search for it on the page before making any edits or updates.'
}
